import {
  BarChart2,
  PieChart,
  Donut,
  TrendingUp,
  AreaChart,
  Table2,
  Hash,
  BarChartHorizontal,
  LayoutList,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import type { WidgetType } from '../../types';

const WIDGET_TYPES: Array<{ type: WidgetType; icon: React.ReactNode }> = [
  { type: 'counter', icon: <Hash className="h-5 w-5" /> },
  { type: 'pie', icon: <PieChart className="h-5 w-5" /> },
  { type: 'donut', icon: <Donut className="h-5 w-5" /> },
  { type: 'bar', icon: <BarChart2 className="h-5 w-5" /> },
  { type: 'horizontal_bar', icon: <BarChartHorizontal className="h-5 w-5" /> },
  { type: 'stacked_bar', icon: <LayoutList className="h-5 w-5" /> },
  { type: 'line', icon: <TrendingUp className="h-5 w-5" /> },
  { type: 'area', icon: <AreaChart className="h-5 w-5" /> },
  { type: 'table', icon: <Table2 className="h-5 w-5" /> },
];

interface StepTypeSelectorProps {
  selected: WidgetType | null;
  onSelect: (type: WidgetType) => void;
}

export function StepTypeSelector({ selected, onSelect }: StepTypeSelectorProps) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="flex w-full flex-col gap-0.5">
      {WIDGET_TYPES.map(({ type, icon }) => (
        <button
          key={type}
          type="button"
          aria-pressed={selected === type}
          data-testid={`dashboard-type-selector-${type.replace('_', '-')}`}
          onClick={() => onSelect(type)}
          className={cn(
            'flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm transition-colors hover:bg-muted',
            selected === type
              ? 'bg-primary/10 text-primary font-medium ring-1 ring-primary'
              : 'text-foreground',
          )}
        >
          {icon}
          <span className="truncate">{t(`widgetTypes.${type}`)}</span>
        </button>
      ))}
    </div>
  );
}
